import { MapPin, Phone, Mail, Clock, ArrowUpRight, Wrench } from "lucide-react";
import { SectionHead } from "@/components/site/PageHeader";
import { Reveal, Stagger, Item } from "@/components/motion/Reveal";
import { telLink, waLink } from "@/lib/format";

export const InfoRows = ({ settings = {} }) => {
  const rows = [
    { icon: MapPin, label: "Showroom", value: settings.address, testid: "info-address" },
    { icon: Phone, label: "Sales", value: settings.phone, href: telLink(settings.phone), testid: "info-phone" },
    settings.phone_alt && { icon: Phone, label: "Service & Parts", value: settings.phone_alt, href: telLink(settings.phone_alt), testid: "info-phone-alt" },
    settings.email && { icon: Mail, label: "Email", value: settings.email, href: `mailto:${settings.email}`, testid: "info-email" },
    { icon: Clock, label: "Showroom hours", value: settings.hours_showroom, testid: "info-hours-showroom" },
    { icon: Wrench, label: "Workshop hours", value: settings.hours_workshop, testid: "info-hours-workshop" },
  ].filter(Boolean);
  return (
    <Stagger className="divide-y divide-white/10 border-y border-white/10" gap={0.06}>
      {rows.map((r) => (
        <Item key={r.label} className="grid grid-cols-[28px_1fr] items-start gap-4 py-5 sm:grid-cols-[28px_160px_1fr]">
          <r.icon className="mt-0.5 h-4 w-4 text-crimson" />
          <p className="eyebrow pt-0.5">{r.label}</p>
          {r.href ? (
            <a href={r.href} data-testid={r.testid} className="col-start-2 font-display text-base text-white transition-colors hover:text-gold sm:col-start-3">{r.value}</a>
          ) : (
            <p data-testid={r.testid} className="col-start-2 font-display text-base text-white sm:col-start-3">{r.value}</p>
          )}
        </Item>
      ))}
    </Stagger>
  );
};

export const MapFrame = ({ settings = {}, className = "" }) => (
  <div className={`clip-frame relative overflow-hidden border border-white/10 bg-surface ${className}`}>
    {settings.map_embed ? (
      <iframe
        title="West Canal Motors location"
        src={settings.map_embed}
        data-testid="location-map"
        className="map-dark h-full w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    ) : (
      <div className="flex h-full items-center justify-center text-slate-500">Map not configured</div>
    )}
  </div>
);

export const LocationSection = ({ settings = {}, number = "04" }) => (
  <section id="contact" data-testid="location-section" className="border-t border-white/10 py-24 sm:py-32">
    <div className="wrap grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHead number={number} eyebrow="Visit us" lines={["West Canal Road,", `${settings.city || "Faisalabad"}.`]} className="mb-10" />
        <InfoRows settings={settings} />
        <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-4">
          {settings.map_url && <a href={settings.map_url} target="_blank" rel="noreferrer" data-testid="location-directions-button" className="btn-crimson">Get Directions <ArrowUpRight className="h-4 w-4" /></a>}
          {settings.whatsapp && <a href={waLink(settings.whatsapp, "Hello West Canal Motors, I'd like to visit the showroom.")} target="_blank" rel="noreferrer" data-testid="location-whatsapp-button" className="btn-ghost">WhatsApp</a>}
        </Reveal>
      </div>
      <Reveal className="lg:col-span-7" y={50} delay={0.15}>
        <MapFrame settings={settings} className="h-[420px] lg:h-full lg:min-h-[560px]" />
      </Reveal>
    </div>
  </section>
);
